import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';
import { DEFAULT_CODE } from 'site-modules/editorial/pages/obd-dtc/constants';

/**
 * route for each vehicle type
 * @type {Array}
 */
export const obdDtcRoutes = [
  /**
   * https://www.edmunds.com/obd-dtc/p0420/
   */
  {
    path: ['/obd-dtc', '/obd-dtc/:codeId.html'],
    exact: true,
    page: getLoadablePage(({ codeId = DEFAULT_CODE }) =>
      import(/* webpackChunkName: "obd-dtc" */ '../pages/obd-dtc/obd-dtc-code-definition').then(page =>
        page.default({ codeId })
      )
    ),
    chunkName: 'obd-dtc',
  },
];
